<template name="addApproved">
  <div class="addApproved">
    <div class="people-list">
      <div>
        <div class="row" v-for="(user, idx) in approvedList" :key="idx">
          <div class="col-10">
            <img class="head-portrait" :id="user.id" :src="user.avatar">
            <span>{{ user.userName }}({{ user.deptName }})</span>
          </div>
          <div class="col-2">
            <img class="delete-people" src="../assets/images/2-copy-12@2x.png"
             @click="deleteKO(user.id)">
          </div>
        </div>
      </div>
    </div>
    <div class="addBtn new-invite-title" @click="changeKO">
      <i class="iconfont icon-add"></i><span>{{$t('AddOtheApprover')}}</span>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'addApproved',
  props: {
    approvedList: Array,
  },
  data() {
    return {
    };
  },
  methods: {
    changeKO() {
      this.$emit('koStatus', { type: 'approved' });
    },
    deleteKO(id) {
      this.$emit('deleteKO', { type: 'approved', id });
    },
  },
};
</script>

<style scoped lang="scss">
  .addApproved {
    width: 100%;
    margin: auto;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    background-color: #fff;
    border-radius: 4px;
    .addBtn {
      padding: 12px;
      img {
        width: 21px;
        height: 22px;
        margin-right: 6px;
      }
      span {
        color: #4a4a4a;
      }
    }
    .people-list {
      border-bottom: 1px solid #f0f1f2;
      & > div {
        padding: 0 12px;
        .row {
          margin: 0;
          padding-top: 5px;
          padding-bottom: 5px;
          align-items: center;
          border-bottom: 1px solid #f0f1f2;
          div {
            padding: 0;
            // font-family: HiraginoSansGB-W3;
            font-size: 13px;
            color: #4a4a4a;
            img.head-portrait {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 10px;
            }
            .delete-people {
              width: 20px;
              height: 20px;
            }
          }
          & > div:nth-of-type(2) {
            text-align: right;
            padding-right: 10px;
          }
        }
      }
    }
  }
</style>
